import * as client from "@infrastructure/ClientConsumer";

const routes = {
    GET_GAME_TEAM_HISTORIES: "/posts/:postId/game-team-history",
};

export enum GameResultEnum {
    WIN = "win",
    LOSS = "loss",
    DRAW = "draw",
}

export type TeamHistoriesType = {
    teamHistories: {
        teamAwayHistory: {
            gameResult: GameResultEnum;
        }[];
        teamHomeHistory: {
            gameResult: GameResultEnum;
        }[];
    };
};

export async function getGameTeamHistories(
    postId: string,
): Promise<TeamHistoriesType> {
    const res = await client.getData(
        routes.GET_GAME_TEAM_HISTORIES.replace(":postId", postId),
    );
    return res.data;
}
